import { AsyncAction } from "@/Common/Api/AsyncActions/AsyncAction";
import { QuestionnaireAnswer } from "@/Common/Models/Questionnaires/QuestionnaireAnswer";
import { QuestionnaireFormTemplateResponse } from "@/Common/Models/Questionnaires/QuestionnaireFormTemplateResponse";
import * as ServerOperations from "@/Common/Operations/operations.server";

class QuestionnaireAction extends AsyncAction {
    public loadFormTemplate(questionnaireInstanceId: string): Promise<QuestionnaireFormTemplateResponse> {
        return this.postAsync<QuestionnaireFormTemplateResponse>(
            ServerOperations.Server.Myle_Questionnaire_GetFormTemplate,
            {
                QuestionnaireInstanceId: questionnaireInstanceId
            }
        );
    }

    public submit(questionnaireInstanceId: string, answers: QuestionnaireAnswer[]): Promise<{ Result: boolean }> {
        return this.postAsync<{ Result: boolean }>(
            ServerOperations.Server.Myle_Questionnaire_Submit,
            {
                QuestionnaireInstanceId: questionnaireInstanceId,
                Answers: answers
            }
        );
    }
}

export { QuestionnaireAction };
